import {
  USER_ROLE_ADMIN,
  USER_ROLE_DOCTOR,
} from '../../constants';
import BaseVoter from './base';

class StrategyVoter extends BaseVoter {
  /**
   * @param User user
   * @returns {boolean}
   */
  canView (user) {
    return this.isUser(user);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canEdit (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_DOCTOR]);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canChangeStatus (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_DOCTOR]);
  }
}

export default new StrategyVoter();
